import styled from 'styled-components';

export const PaymentMethodOptionItemDivider = styled.hr`
  height: 1px;
  background-color: ${Styles.color.grey.four};
  border: 0;
  margin: 0;
`;

export const StyledOption = styled.div`
  background: transparent;

  &:hover {
    background: initial;
  }
  ${Styles.desktop`
    &:hover {
      background: ${Styles.color.grey.five};
    }
  `}
`;
